import React from 'react';
import { MdClose } from 'react-icons/md';

import Modal, { SubModalProps } from '../../components/Modal';
import Button from '../../components/Button';
import imgModal from '../../assets/you.svg';

import { Content } from './styles';

const RegisterStartupModal: React.FC<SubModalProps> = ({ closeModal }) => {
  return (
    <Modal maxWidth={540} closeModal={closeModal}>
      <Content>
        <div>
          <button type="button" onClick={closeModal}>
            <MdClose size={25} />
          </button>
        </div>

        <img src={imgModal} alt="modal" />

        <h1>Assinar a CINCO é simples </h1>

        <p>Por aqui, nos informe apenas os dados do responsável financeiro.</p>

        <p>
          Após a conclusão do pagamento, entraremos em contato com você para
          coletar os dados da pessoa que receberá os cuidados da CINCO
        </p>

        <Button type="button" onClick={closeModal}>
          Começar
        </Button>
      </Content>
    </Modal>
  );
};

export default RegisterStartupModal;
